
<div class="landing-routes-container">
    <div  class="landing-items-contained">
        <div class="landing-page-button-container" *ngIf="userIsLoggedIn()">
            <dx-button i18n-text icon="smalliconslayout" class="root-landing-page-button" text="DASHBOARD PLACEHOLDER: NAVIGATE TO KONTAKTS PAGE VIA THE SIDE MENU" routerLink="/persons-list"></dx-button>
        </div>
    </div>     
</div>
